"use client";

import { getCookieValue, setCookieValue } from "@/utils/cookies";
import { useMemo } from "react";
import { useRouter, useSearchParams } from "next/navigation";
import { useApi } from "./useApi";
import getApplicationInfoHandler from "@/interface/api/GetApplicationInfo";
import * as log from "@/actions/logger";

const defaultConfig = {
  redirect: { allow: false, to: "/" },
};

const useGetApplication = ({ redirect } = defaultConfig) => {
  const searchParams = useSearchParams();
  const router = useRouter();

  const getUrlParams = () => {
    let params: Record<string, string> = {};
    for (const [key, value] of searchParams.entries()) {
      params[key] = value;
    }

    return params;
  };

  const applicationId = useMemo(() => {
    const { order, pdf, tag, id } = getUrlParams();
    const orderCookie = getCookieValue("address_token");
    if (order && pdf) {
      setCookieValue("address_token", {
        ...orderCookie,
        order: order,
        applicationId: order,
        pdfId: pdf,
      });
    }

    if (tag) {
      setCookieValue("tag_param", { tag: tag });
    }
    return id || order || orderCookie?.order;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const redirectTo = () => {
    if (redirect.allow) {
      router.push(redirect.to);
    }
  };

  const { request: requestGetApplicationInfo, data: dataGetApplicationInfo } = useApi(
    getApplicationInfoHandler.getApplicationInfo
  );

  const getApplicationInfo = async () => {
    requestGetApplicationInfo({ applicationId })
      .then((response: any) => {
        if (response?.status !== "registered") {
          redirectTo();
        }
        return response;
      })
      .catch((e: any) => {
        log.error(
          { err: e, applicationId, module: "useGetApplication" },
          "Error getting site info"
        );
        redirectTo();
      });

    return dataGetApplicationInfo;
  };

  return {
    applicationId,
    getApplicationInfo,
  };
};

export default useGetApplication;
